<section class="py-10 bg-[#f8fafc] font-sans selection:bg-orange-100">
  <div class="max-w-7xl mx-auto px-6 text-center mb-20">
    <h2 class="text-4xl md:text-6xl font-black text-[#002670] mb-6 tracking-tight">
      মেন্টরই<span class="text-orange-500">আরপি</span> সফটওয়্যারের <span
        class="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-600">প্যাকেজ ও মূল্য</span>
    </h2>
    <div class="flex flex-col md:flex-row justify-center items-center gap-4">
      <div class="px-6 py-2 bg-orange-50 border border-orange-100 rounded-full shadow-sm">
        <p class="text-orange-600 font-bold text-sm md:text-base italic">সিলভার প্যাকেজ: ন্যূনতম ২,০০০৳ / মাস</p>
      </div>
      <div class="px-6 py-2 bg-blue-50 border border-blue-100 rounded-full shadow-sm">
        <p class="text-blue-600 font-bold text-sm md:text-base italic">গোল্ড প্যাকেজ: ন্যূনতম ৪,০০০৳ / মাস</p>
      </div>
    </div>
  </div>

  <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10 items-stretch mb-10">
    @for (plan of pricingPlans; track plan.name) {
    <div class="flex flex-col group relative">
      @if(plan.isFeatured) {
      <div
        class="absolute -top-4 left-1/2 -translate-x-1/2 z-20 bg-orange-500 text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-widest shadow-lg">
        Most Popular
      </div>
      }

      <div
        class="bg-white rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,38,112,0.05)] border border-gray-100 transition-all duration-500 flex flex-col overflow-hidden min-h-[700px] group-hover:shadow-[0_30px_60px_rgba(0,38,112,0.12)] group-hover:-translate-y-2 relative"
        [class.border-blue-400]="plan.isFeatured" [class.ring-4]="plan.isFeatured"
        [class.ring-blue-50]="plan.isFeatured">

        <div class="p-10 text-center text-white relative overflow-hidden bg-gradient-to-br {{ plan.gradient }}">
          <div
            class="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white to-transparent">
          </div>
          <h3 class="text-3xl font-black mb-4 relative z-10">{{ plan.name }}</h3>
          <div
            class="bg-white/20 backdrop-blur-md rounded-2xl py-3 px-8 inline-block border border-white/30 relative z-10">
            <span class="text-4xl font-black tracking-tighter italic">৳{{ plan.price }}</span>
          </div>
        </div>

        <div class="px-10 py-8 flex-grow">
          <ul class="space-y-4">
            @for (item of plan.features; track item.text) {
            <li class="flex items-start gap-3 text-[13px] leading-relaxed transition-colors duration-300"
              [class.opacity-40]="item.status === 'cross'" [class.text-gray-600]="item.status === 'check'">
              <span class="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px]"
                [class.bg-green-100]="item.status === 'check'" [class.text-green-600]="item.status === 'check'"
                [class.bg-gray-100]="item.status === 'cross'" [class.text-gray-400]="item.status === 'cross'">
                {{ item.status === 'check' ? '✔' : '✕' }}
              </span>
              <span [class.text-blue-700]="item.highlight" [class.font-bold]="item.highlight">
                {{ item.text }}
              </span>
            </li>
            }
          </ul>
        </div>
      </div>

      <button
        class="mt-8 mx-auto w-full max-w-[200px] cursor-pointer py-4 text-white font-black text-sm rounded-2xl shadow-xl transition-all duration-300 hover:scale-105 active:scale-95 bg-gradient-to-r {{ plan.gradient }} {{ plan.shadow }}">
        {{ plan.btnText }}
      </button>
    </div>
    }
  </div>
</section>